import { GET_ALL_ASSETS, GET_ASSET_INFO_BY_ID, GET_WELL_KNOWN_ASSETS, SEARCH_ASSETS } from "helpers/constants";

export const Assets = (assets = null, action) => {
	switch (action.type) {
		case GET_ALL_ASSETS:
			return action.payload;

		default:
			return assets;
	}
};

export const WellKnownAssets = (wellKnownAssets = null, action) => {
	switch (action.type) {
		case GET_WELL_KNOWN_ASSETS:
			return action.payload;

		default:
			return wellKnownAssets;
	}
};

export const AssetInfo = (assetInfo = null, action) => {
	switch (action.type) {
		case GET_ASSET_INFO_BY_ID:
			return action.payload;

		default:
			return assetInfo;
	}
};

export const searchAssets = (searchAssets = null, action) => {
	switch (action.type) {
		case SEARCH_ASSETS:
			return action.payload;

		default:
			return searchAssets;
	}
};
